import { api } from "../../../lib/api";

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const MONTHS = ["Todos", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

export const CAT_LABEL = { ingreso: "Ingreso", egreso: "Egreso", nomina: "Nómina", pago: "Pago", otro: "Otro" };

export const CAT_CLS = {
  ingreso: "bg-emerald-500/10 text-emerald-600",
  egreso: "bg-destructive/10 text-destructive",
  nomina: "bg-violet/10 text-violet",
  pago: "bg-gold/15 text-gold",
  otro: "bg-navy/10 text-navy/60",
};

export async function downloadDoc(kind, id, filename, att) {
  const q = att ? `&att=${att}` : "";
  const r = await api.get(`/accounting/download?kind=${kind}&id=${id}${q}`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "archivo";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
